var _g, _mask, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPencilBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29853 12.2015C4.27249 12.2275 4.24211 12.2471 4.20739 12.2601L0.717874 13.6533C0.687493 13.662 0.652772 13.6663 0.61371 13.6663C0.544266 13.6663 0.476994 13.6403 0.411891 13.5882C0.338107 13.5144 0.316407 13.4124 0.346788 13.2822L1.73999 9.7927C1.75301 9.75797 1.77254 9.72759 1.79858 9.70155L8.4548 3.04533C8.57196 2.92818 8.76191 2.92818 8.87906 3.04533L10.9547 5.12102C11.0719 5.23818 11.0719 5.42812 10.9547 5.54528L4.29853 12.2015ZM13.4194 1.88921C13.5844 2.06282 13.6668 2.26355 13.6668 2.49141C13.6668 2.71927 13.5844 2.91566 13.4194 3.08059L12.2123 4.2877C12.0952 4.40486 11.9052 4.40486 11.7881 4.2877L9.71238 2.21202C9.59522 2.09486 9.59522 1.90491 9.71238 1.78775L10.9195 0.580643C11.0844 0.415715 11.2808 0.333252 11.5087 0.333252C11.7365 0.333252 11.9373 0.415715 12.1109 0.580643L13.4194 1.88921Z",
    fill: "#8A8888"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29853 12.2015C4.27249 12.2275 4.24211 12.2471 4.20739 12.2601L0.717874 13.6533C0.687493 13.662 0.652772 13.6663 0.61371 13.6663C0.544266 13.6663 0.476994 13.6403 0.411891 13.5882C0.338107 13.5144 0.316407 13.4124 0.346788 13.2822L1.73999 9.7927C1.75301 9.75797 1.77254 9.72759 1.79858 9.70155L8.4548 3.04533C8.57196 2.92818 8.76191 2.92818 8.87906 3.04533L10.9547 5.12102C11.0719 5.23818 11.0719 5.42812 10.9547 5.54528L4.29853 12.2015ZM13.4194 1.88921C13.5844 2.06282 13.6668 2.26355 13.6668 2.49141C13.6668 2.71927 13.5844 2.91566 13.4194 3.08059L12.2123 4.2877C12.0952 4.40486 11.9052 4.40486 11.7881 4.2877L9.71238 2.21202C9.59522 2.09486 9.59522 1.90491 9.71238 1.78775L10.9195 0.580643C11.0844 0.415715 11.2808 0.333252 11.5087 0.333252C11.7365 0.333252 11.9373 0.415715 12.1109 0.580643L13.4194 1.88921Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: -3,
    width: 20,
    height: 20,
    fill: "#255EBA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(0.333496 0.333252)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPencilBlue);
export default __webpack_public_path__ + "static/media/ic-pencil_blue.4d53c9fda1865e12e075060645ee4f67.svg";
export { ForwardRef as ReactComponent };